import React from 'react';
import ImageGenerationModal from './ImageGenerationModal';
import { useImageGenerationModalStore } from '@/services/imageModalService';

/**
 * Container component that connects the modal to the existing Zustand store
 * This should be placed at the root level of the app (e.g., in App.tsx)
 */
const ImageGenerationModalContainer: React.FC = () => {
  const { 
    isOpen, 
    recipe, 
    source, 
    closeModal 
  } = useImageGenerationModalStore();

  // Don't render modal if recipe is null
  if (!recipe || !source) {
    return null;
  }

  return (
    <ImageGenerationModal
      isOpen={isOpen}
      onClose={closeModal}
      recipe={recipe}
      source={source}
    />
  );
};

export default ImageGenerationModalContainer;